'use client';
import React from 'react';
import Button from '../forms/Button';
import { cn } from '../utils/cn';
import ArrowleftIcon from '../icons/ArrowLeft';
import Link from 'next/link';

type MenuCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: {
    text: string;
    onClick: () => void;
  };
  href: string;
  className?: string;
  onNavigationStart?: () => void;
};

export function MenuCard({
  icon,
  title,
  description,
  action,
  href,
  className,
  onNavigationStart,
}: MenuCardProps) {
  return (
    <Link
      href={href}
      onClick={onNavigationStart}
      className={cn(
        ' bg-el-grey-100  group flex flex-col gap-2 rounded-4 p-5 max-sm:w-full  md:w-[350px] h-[132px] hover:shadow-hover transition-all duration-600',
        className
      )}
    >
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-4 ">
          {icon}
          <h3 className="text-34/[90%] font-bold ">{title}</h3>
        </div>
        <div className="text-grey-200 group-hover:text-el-blue-500  ">
          <ArrowleftIcon className="transition-all duration-600" />
        </div>
      </div>
      <p className="  text-14 text-el-grey-500">{description}</p>
      {action && (
        <div className="">
          <Button
            className="button-primary-inverse"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              action.onClick();
            }}
          >
            <span className="flex items-center gap-2">
              <span>+</span>
              <span>{action.text}</span>
            </span>
          </Button>
        </div>
      )}
    </Link>
  );
}
